import { Button, Col, Container, Row } from '@dbi-tools/ui-kit';
import React from 'react';
import { connect } from 'react-redux';
import { ValidationErrorsInterface } from 'react-uforms';

import GoogleAnalytics from '../components/common/google-analytics';
import FooterText from '../components/footer-text';
import { isValue } from '../service/helpers';
import { goBack } from '../store/quiz/thunks';
import { QuizValues } from '../store/quiz/types';
import { RootState } from '../store/root-reducer';
import { Question } from '../types/question';
import { ThunkActionDispatch } from '../types/store-types';
import { FooterStyled, FooterTextStyled } from './footer.styled';

interface FooterProps {
  errors?: ValidationErrorsInterface;
  values: QuizValues;
  currentQuestions: Question[];
  prevStepSlug: string;
  currentSlug: string;
  goBack: ThunkActionDispatch<typeof goBack>;
}

export const isDisabled = (
  values: QuizValues,
  currentQuestions: Question[],
  errors?: ValidationErrorsInterface,
): boolean => {
  const isDisabled = currentQuestions.find((item) => item.required && !isValue(values, item.name));
  const stepErrors = currentQuestions.map((el) => errors[el.name]).filter((el: string[]) => el && el.length > 0);
  return !!(isDisabled || stepErrors.length > 0);
};

export const isSkipped = (values: QuizValues, currentQuestions: Question[]): boolean =>
  !currentQuestions.find((item) => item.required || isValue(values, item.name));

const Footer: React.FC<FooterProps> = ({ errors, values, currentQuestions, prevStepSlug, currentSlug, goBack }) => {
  const disabled = isDisabled(values, currentQuestions, errors);
  const buttonKey = `next_${currentSlug}_${disabled.toString()}`;
  return (
    <FooterStyled>
      <Container>
        <Row>
          <Col lg={6}>
            <FooterTextStyled>
              <FooterText errors={errors} />
            </FooterTextStyled>
          </Col>
          <Col lg={5} lgOffset={1} xl={4} xlOffset={2}>
            <Row>
              <Col col={6}>
                {prevStepSlug && prevStepSlug !== '/' && (
                  <Button
                    key={`prev_${currentSlug}`}
                    variant="outlined"
                    color="gray700"
                    fullWidth
                    onClick={() => goBack()}
                    disabled={!prevStepSlug || prevStepSlug === '/'}
                    type="button"
                  >
                    Go Back
                  </Button>
                )}
              </Col>
              <Col col={6}>
                <Button
                  type="submit"
                  fullWidth
                  variant={isSkipped(values, currentQuestions) ? 'outlined' : 'solid'}
                  color={isSkipped(values, currentQuestions) ? 'gray700' : 'primaryDark'}
                  onClick={() => {
                    GoogleAnalytics.sendAnswers({ values, currentQuestions });
                  }}
                  key={buttonKey}
                  disabled={disabled}
                >
                  {isSkipped(values, currentQuestions) ? 'skip' : 'continue'}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </FooterStyled>
  );
};

const mapStateToProps = (state: RootState) => ({
  prevStepSlug: state.quizState.prevStepSlug,
  currentSlug: state.quizState.currentStep.slug,
});

export default connect(mapStateToProps, { goBack })(Footer);
